import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';

const InvoicesFilters = ({ statusFilter, onFilterChange }) => {
  const filters = [
    { value: 'all', label: 'All' },
    { value: 'pending', label: 'Pending' },
    { value: 'paid', label: 'Paid' }
  ];

  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex gap-2">
          {filters.map(filter => (
            <Button
              key={filter.value}
              variant={statusFilter === filter.value ? 'default' : 'outline'}
              size="sm"
              onClick={() => onFilterChange(filter.value)}
            >
              {filter.label}
            </Button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default InvoicesFilters;
